import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './SignupForm.css';

const SignupForm = ({ onClose, onSwitchToLogin }) => {
  const { signup, loginWithSSO } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    username: ''
  });
  const [agreeToTerms, setAgreeToTerms] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEmailSignup = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setError('');

    // Validation
    if (formData.password !== formData.confirmPassword) {
      setError('Passwords do not match');
      setIsLoading(false);
      return;
    }

    if (!agreeToTerms) {
      setError('Please agree to the terms and conditions');
      setIsLoading(false);
      return;
    }

    try {
      const result = await signup(formData.email, formData.password, formData.username);
      if (!result.success) {
        setError(result.error || 'Failed to create account');
      }
    } catch (err) {
      setError('Failed to create account. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };

  const handleSSOSignup = async (provider) => {
    setIsLoading(true);
    setError('');

    try {
      const result = await loginWithSSO(provider);
      if (!result.success) {
        setError(result.error || `Failed to sign up with ${provider}`);
      }
    } catch (err) {
      setError(`Failed to sign up with ${provider}`);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signup-overlay">
      <div className="signup-container">
        <div className="signup-header">
          <h2>Create Account</h2>
          <button className="close-btn" onClick={onClose}>
            <i className="fas fa-times"></i>
          </button>
        </div>

        <form onSubmit={handleEmailSignup} className="signup-form">
          <div className="input-group">
            <input
              type="text"
              name="username"
              placeholder="username"
              value={formData.username}
              onChange={handleInputChange}
              required
              className="signup-input"
            />
          </div>

          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="email"
              value={formData.email}
              onChange={handleInputChange}
              required
              className="signup-input"
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              name="password"
              placeholder="password"
              value={formData.password}
              onChange={handleInputChange}
              required
              className="signup-input"
              minLength="6"
            />
          </div>

          <div className="input-group">
            <input
              type="password"
              name="confirmPassword"
              placeholder="confirm password"
              value={formData.confirmPassword}
              onChange={handleInputChange}
              required
              className="signup-input"
            />
          </div>

          <div className="terms-agreement">
            <label className="checkbox-container">
              <input
                type="checkbox"
                checked={agreeToTerms}
                onChange={(e) => setAgreeToTerms(e.target.checked)}
                required
              />
              <span className="checkmark"></span>
              I agree to the <button type="button" className="terms-link">Terms and Conditions</button> and <button type="button" className="privacy-link">Privacy Policy</button>
            </label>
          </div>

          {error && <div className="error-message">{error}</div>}

          <button 
            type="submit" 
            className="signup-btn"
            disabled={isLoading}
          >
            {isLoading ? 'CREATING ACCOUNT...' : 'SIGN UP'}
          </button>
        </form>

        <div className="divider">
          <span>OR</span>
        </div>

        <div className="sso-buttons">
          <button 
            className="sso-btn kakao"
            onClick={() => handleSSOSignup('kakao')}
            disabled={isLoading}
          >
            <div className="sso-icon">
              <i className="fas fa-comment"></i>
            </div>
            <span>TALK</span>
          </button>

          <button 
            className="sso-btn naver"
            onClick={() => handleSSOSignup('naver')}
            disabled={isLoading}
          >
            <div className="sso-icon">N</div>
          </button>

          <button 
            className="sso-btn google"
            onClick={() => handleSSOSignup('google')}
            disabled={isLoading}
          >
            <div className="sso-icon">G</div>
          </button>

          <button 
            className="sso-btn apple"
            onClick={() => handleSSOSignup('apple')}
            disabled={isLoading}
          >
            <div className="sso-icon">
              <i className="fab fa-apple"></i>
            </div>
          </button>
        </div>

        <div className="login-link">
          <span>Already have an account? </span>
          <button onClick={onSwitchToLogin} className="login-link-btn">
            Sign In Here
          </button>
        </div>
      </div>
    </div>
  );
};

export default SignupForm;
